import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceDoctorRecordTypeModalStore } from './service-doctor-record-type-modal.store';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FormBuilder, Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    ServiceDoctorRecordTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-docker-record-type.object';
import {
    ServiceDoctorRecordTypeUpdateInput,
} from '@libs/types/src/services/input-type/services/settings/service-doctor-record-type.update-input';
import {
    ServiceDoctorRecordTypeCreateInput,
} from '@libs/types/src/services/input-type/services/settings/service-doctor-record-type.create-input';
import { contentGlobalSuccess } from '../../../../content.error';
import { routeParams } from '../../../../../shared/shared.global-service';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import { FormatServiceProcedurePipe } from '../../../../../shared/pipes/format-service-procedure.pipe';
import {
    MultiSelectInputComponent,
} from '../../../../../../components/kit/input/multi-select-input/multi-select-input.component';
import {
    PerformedProceduresComponent,
} from '../../../../../shared/components/kit/performed-procedures/performed-procedures.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TransformSingleServiceProceduresPipe } from '../../../../../shared/components/kit/performed-procedures/performed-procedures.pipes';

@Component({
    selector: 'app-service-doctor-record-type-modal',
    templateUrl: 'service-doctor-record-type-modal.component.html',
    styleUrl: 'service-doctor-record-type-modal.component.scss',
    providers: [
        ServiceDoctorRecordTypeModalStore,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        CheckInputComponent,
        TextInputComponent,
        ActionButtonsComponent,
        FormatServiceProcedurePipe,
        MultiSelectInputComponent,
        PerformedProceduresComponent,
        PrimeTemplate,
        TransformSingleServiceProceduresPipe,
    ],
})
export class ServiceDoctorRecordTypeModalComponent extends SubscriptionComponent {
    protected readonly store = inject(ServiceDoctorRecordTypeModalStore);
    private readonly fb = inject(FormBuilder);


    @Input() doctorRecordType: ServiceDoctorRecordTypeObject | null = null;

    protected visible = false;

    protected form = this.fb.group({
        active: this.fb.control<boolean>(true),
        name: this.fb.control<string>('', Validators.required),
        description: this.fb.control<string>(''),
        procedures: this.fb.control<string[]>([]),
    });

    public show(visible: boolean = true, doctorRecordType: ServiceDoctorRecordTypeObject | null = null): void {
        this.visible = visible;
        this.doctorRecordType = doctorRecordType;
        if (doctorRecordType) {
            this.form.patchValue({
                ...doctorRecordType,
                procedures: doctorRecordType.procedures.map((it) => it.code),
            });
        }
    }

    protected async submit(): Promise<void> {
        if (isInvalid(this.form)) return;

        if (!this.doctorRecordType) {
            const serviceId = Number(routeParams.serviceId());
            this.store.api.createServiceDoctorRecordType({
                serviceId,
                ...this.form.value,
                procedures: this.form.value.procedures || [],
                active: this.form.value.active ?? false,
            } as ServiceDoctorRecordTypeCreateInput).then();
            contentGlobalSuccess.next('common.created');
        } else {
            this.store.api.updateServiceDoctorRecordType({
                id: this.doctorRecordType!.id,
                ...this.form.value,
                procedures: this.form.value.procedures || [],
                active: this.form.value.active ?? false,
            } as ServiceDoctorRecordTypeUpdateInput).then();
            contentGlobalSuccess.next('common.updated');
        }
        this.form.reset();

        this.show(false);
    }

}
